var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, computed, observable, toJS, extendObservable, makeObservable } from 'mobx';
import UserActionsAPI from '../services/UserActionsAPI';
import CarsAPI from '../services/CarsAPI';
import { history } from '../AppRouter';
import _assignWith from 'lodash/assignWith';
import NotificationStore from './NotificationStore';
import { ShowNotificationError } from '../framework/ErrorLogger';
import { i18nextInstance } from '../../i18n';
import _get from 'lodash/get';
import _set from 'lodash/set';
import { emptyGuaranteeFormItem, withEditPageSource, guaranteeItemsFromCar, isBlankGuaranteeItem, validateGuaranteeItem } from '../components/pages/VehicleEditPage/sections/Guarantee/guaranteeForm';
class VehicleEditStore {
    constructor() {
        Object.defineProperty(this, "car", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "isFetching", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isSaving", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "errorMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "templates", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "tiresSets", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable.map({})
        });
        Object.defineProperty(this, "isAvailableCar", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        // car.guarantee.items[] — kept outside VehicleEditForm (like tiresSets): it's a dynamic list
        Object.defineProperty(this, "guaranteeItems", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "showGuaranteeErrors", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "currentTemplate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                _id: '',
                title: ''
            }
        });
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "clearCurrentTemplate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.currentTemplate.title = '';
                this.currentTemplate._id = '';
            }
        });
        Object.defineProperty(this, "onChangeSelectTemplate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (option) => {
                this.currentTemplate._id = option.value;
                this.currentTemplate.title = option.label;
            }
        });
        Object.defineProperty(this, "onChangeTitleTemplate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                this.currentTemplate.title = value;
            }
        });
        Object.defineProperty(this, "setStatus", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                this.status = value;
            }
        });
        Object.defineProperty(this, "intervalShowMassage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const time = 5000;
                setTimeout(() => {
                    this.status = '';
                }, time); // eslint-disable-line
            }
        });
        Object.defineProperty(this, "getTemplates", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (userID) => {
                this.setStatus('pending');
                return UserActionsAPI.getAllTemplates(userID)
                    .then((res) => {
                    this.setStatus('success');
                    this.intervalShowMassage();
                    this.templates = res.data;
                })
                    .catch((err) => {
                    this.setStatus('error');
                    this.intervalShowMassage();
                });
            }
        });
        Object.defineProperty(this, "sendTemplate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (userID, value) => {
                this.setStatus('pending');
                const reqObj = {
                    title: this.currentTemplate.title,
                    text: value
                };
                return UserActionsAPI.sendingTemplate(reqObj)
                    .then((res) => {
                    this.setStatus('success');
                    this.intervalShowMassage();
                    return this.getTemplates(userID);
                })
                    .catch((err) => {
                    this.setStatus('error');
                    this.intervalShowMassage();
                });
            }
        });
        Object.defineProperty(this, "updateTemplate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (userID, value) => {
                this.setStatus('pending');
                const reqObj = {
                    title: this.currentTemplate.title,
                    text: value
                };
                const id = this.currentTemplate._id;
                return UserActionsAPI.updateTemplate(id, reqObj)
                    .then((res) => {
                    this.setStatus('success');
                    this.intervalShowMassage();
                    return this.getTemplates(userID);
                })
                    .catch((err) => {
                    this.setStatus('error');
                    this.intervalShowMassage();
                });
            }
        });
        Object.defineProperty(this, "deleteActiveTemplate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (userID) => {
                this.setStatus('pending');
                const id = this.currentTemplate._id;
                return UserActionsAPI.deleteTemplate(id)
                    .then((res) => {
                    this.clearCurrentTemplate();
                    this.setStatus('success');
                    this.intervalShowMassage();
                    return this.getTemplates(userID);
                })
                    .catch((err) => {
                    this.setStatus('error');
                    this.intervalShowMassage();
                });
            }
        });
        // This action executes if during
        // car adding stage user selected very unique car
        // and we do not know anything about it so we just
        // take user data and pre-fill car object with it.
        Object.defineProperty(this, "getCarDataFromUser", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (data) => {
                extendObservable(this.car, data);
                return Promise.resolve(this.car);
            }
        });
        // Action to get car object
        // according to car-scheme
        // by car id.
        //
        // Executes when user wants to edit
        // already created car.
        Object.defineProperty(this, "getCar", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id) => {
                this.isFetching = true;
                CarsAPI.getCarData(id, true)
                    .then((response) => {
                    this.car = response;
                    this.guaranteeItems = guaranteeItemsFromCar(_get(response, 'guarantee.items'));
                    this.isFetching = false;
                })
                    .catch((error) => {
                    this.isFetching = false;
                    // TODO: error handling
                    this.isAvailableCar = false;
                    ShowNotificationError();
                });
            }
        });
        // Action to get pre-filled object
        // of the vehicle according
        // to car-scheme by VIN code.
        Object.defineProperty(this, "getCarDataByVIN", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (vinCode) => {
                this.isFetching = true;
                return CarsAPI.getCarDataByVIN(vinCode)
                    .then((response) => {
                    this.isFetching = false;
                    this.car = response;
                })
                    .catch((error) => {
                    this.isFetching = false;
                    ShowNotificationError();
                    throw error;
                });
            }
        });
        // Action to get pre-filled object
        // of the vehicle according to
        // car-scheme by datECode.
        Object.defineProperty(this, "getCarDataByDatGroup", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (datGroupID, inputData = {}) => {
                this.isFetching = true;
                return CarsAPI.getCarDataByDatGroupID(datGroupID)
                    .then((response) => {
                    const extendedCar = {};
                    Object.keys(response).forEach((key) => {
                        const propertyGroup = _assignWith(inputData[key], response[key], (objValue, srcValue) => {
                            return srcValue === null ? objValue : srcValue;
                        });
                        extendedCar[key] = propertyGroup;
                    });
                    extendObservable(this.car, extendedCar);
                    this.isFetching = false;
                    return this.car;
                })
                    .catch((error) => {
                    // show errors here
                    this.isFetching = false;
                    ShowNotificationError();
                });
            }
        });
        Object.defineProperty(this, "updateCarData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (form, type) => {
                const car = toJS(this.car);
                const id = car._id;
                if (_get(car, 'rate.rateMode') === 'dealer') {
                    _set(car, 'rate.rateMode', 'car');
                }
                const data = { ...car, ...form.data };
                const additional = form.additional;
                this.isSaving = true;
                CarsAPI.updateCarData(id, { data, additional })
                    .then((car) => {
                    this.car = car;
                    if (type === 'save') {
                        history.push(`/my-vehicles/overview`);
                    }
                    else {
                        history.push(`/my-vehicles/${id}/image-upload`);
                    }
                })
                    .catch((error) => {
                    const errorCodeDataEqual = 2001;
                    if (error.errors[0].details.errorCode === errorCodeDataEqual) {
                        NotificationStore.addNotification({
                            message: i18nextInstance.t('VehicleEditPage:messages.carEditWarning'),
                            level: 'warning'
                        });
                        if (type === 'save') {
                            history.push(`/my-vehicles/overview`);
                        }
                        else {
                            history.push(`/my-vehicles/${id}/image-upload`);
                        }
                    }
                    else {
                        NotificationStore.addNotification({
                            message: i18nextInstance.t('VehicleEditPage:messages.carCreationError'),
                            level: 'error'
                        });
                    }
                })
                    .finally(() => {
                    this.isSaving = false;
                });
            }
        });
        Object.defineProperty(this, "clearCarData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.car = {};
                this.tiresSets.clear();
                this.guaranteeItems = [];
                this.showGuaranteeErrors = false;
            }
        });
        Object.defineProperty(this, "addEmptyTireSet", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.addNewTireSet();
            }
        });
        Object.defineProperty(this, "addNewTireSet", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (weather) => {
                const tireObj = {
                    type: weather ? weather : '',
                    TiresRims: '',
                    TiresRimsSize: '',
                    TiresTreatDepthBL: '',
                    TiresTreatDepthBR: '',
                    TiresTreatDepthFL: '',
                    TiresTreatDepthFR: ''
                };
                this.tiresSets.set(weather, tireObj);
            }
        });
        Object.defineProperty(this, "deleteTireSet", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (weather) => {
                this.tiresSets.delete(weather);
            }
        });
        Object.defineProperty(this, "setTiresObjectField", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (weather, path, value) => {
                const val = value.value ? value.value : value;
                const currentValue = this.tiresSets.get(weather);
                const newValue = { ...currentValue, [path]: val };
                if (this.tiresSets.has(weather)) {
                    this.tiresSets.set(weather, newValue);
                }
            }
        });
        Object.defineProperty(this, "setShowGuaranteeErrors", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                this.showGuaranteeErrors = value;
            }
        });
        Object.defineProperty(this, "addGuaranteeItem", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.guaranteeItems.push(emptyGuaranteeFormItem());
            }
        });
        Object.defineProperty(this, "removeGuaranteeItem", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (index) => {
                this.guaranteeItems.splice(index, 1);
            }
        });
        Object.defineProperty(this, "setGuaranteeItemField", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (index, key, value) => {
                const item = this.guaranteeItems[index];
                if (!item)
                    return;
                // a dealer edit makes the whole entry backoffice input, even if it originally came from a feed
                this.guaranteeItems[index] = withEditPageSource({ ...item, [key]: value });
            }
        });
        Object.defineProperty(this, "toggleGuaranteeComponent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (index, component) => {
                const item = this.guaranteeItems[index];
                if (!item)
                    return;
                const components = item.components.includes(component)
                    ? item.components.filter((value) => value !== component)
                    : [...item.components, component];
                this.setGuaranteeItemField(index, 'components', components);
            }
        });
        makeObservable(this);
    }
    get guaranteeErrors() {
        return this.guaranteeItems.map((item) => (isBlankGuaranteeItem(item) ? {} : validateGuaranteeItem(item)));
    }
    get isGuaranteeValid() {
        return this.guaranteeErrors.every((errors) => !Object.keys(errors).length);
    }
    get templatesListName() {
        return this.templates.map((template) => {
            return { title: template.title, _id: template._id, text: template.text };
        });
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], VehicleEditStore.prototype, "car", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], VehicleEditStore.prototype, "isFetching", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], VehicleEditStore.prototype, "isSaving", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], VehicleEditStore.prototype, "errorMessage", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], VehicleEditStore.prototype, "templates", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], VehicleEditStore.prototype, "tiresSets", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], VehicleEditStore.prototype, "isAvailableCar", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], VehicleEditStore.prototype, "guaranteeItems", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], VehicleEditStore.prototype, "showGuaranteeErrors", void 0);
__decorate([
    computed,
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], VehicleEditStore.prototype, "guaranteeErrors", null);
__decorate([
    computed,
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], VehicleEditStore.prototype, "isGuaranteeValid", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], VehicleEditStore.prototype, "templatesListName", null);
__decorate([
    observable,
    __metadata("design:type", Object)
], VehicleEditStore.prototype, "currentTemplate", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], VehicleEditStore.prototype, "status", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleEditStore.prototype, "clearCurrentTemplate", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleEditStore.prototype, "onChangeSelectTemplate", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleEditStore.prototype, "onChangeTitleTemplate", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleEditStore.prototype, "setStatus", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleEditStore.prototype, "getTemplates", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleEditStore.prototype, "sendTemplate", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleEditStore.prototype, "updateTemplate", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleEditStore.prototype, "deleteActiveTemplate", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleEditStore.prototype, "getCarDataFromUser", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleEditStore.prototype, "getCar", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleEditStore.prototype, "getCarDataByVIN", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleEditStore.prototype, "getCarDataByDatGroup", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleEditStore.prototype, "updateCarData", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleEditStore.prototype, "clearCarData", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleEditStore.prototype, "addEmptyTireSet", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleEditStore.prototype, "addNewTireSet", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleEditStore.prototype, "deleteTireSet", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleEditStore.prototype, "setTiresObjectField", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleEditStore.prototype, "setShowGuaranteeErrors", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleEditStore.prototype, "addGuaranteeItem", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleEditStore.prototype, "removeGuaranteeItem", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleEditStore.prototype, "setGuaranteeItemField", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleEditStore.prototype, "toggleGuaranteeComponent", void 0);
export default new VehicleEditStore();
